export default __webpack_public_path__ + "static/media/CNo.65-8.89584ab7.jpg";